import { render, staticRenderFns } from "./ImportTarr.vue?vue&type=template&id=7765666f&scoped=true&"
import script from "./ImportTarr.vue?vue&type=script&lang=js&"
export * from "./ImportTarr.vue?vue&type=script&lang=js&"
import style0 from "./ImportTarr.vue?vue&type=style&index=0&id=7765666f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7765666f",
  null
  
)

export default component.exports